export class StartPollingBulkUploadStatus {
  static readonly type = '[BulkUploadDetail] Start Polling Bulk Upload Status';
  constructor(public id: number) {}
}

export class StopPollingBulkUploadStatus {
  static readonly type = '[BulkUploadDetail] Stop Polling Bulk Upload Status';
}

export class SetTimedOutState {
  static readonly type = '[BulkUploadDetail] Set Polling Bulk Upload Timeout';
}
